import Link from '@components/common/Link/Link'
import cn from 'clsx'
import { FC } from 'react'
import { FooterMenuList } from 'types/footerMenuList'
import styles from './MenuList.module.scss'

type MenuListProps = {
  menuList: FooterMenuList
}

const MenuList: FC<MenuListProps> = ({ menuList }) => {
  return (
    <div className={styles.listContainer}>
      <h4 className={cn(styles.headline, 'headerTwo')}>
        {menuList.headerTitle}
      </h4>
      <ul className={styles.menuList}>
        {menuList.links.map((link, index) => (
          <li key={index} className={cn('bodyText')}>
            <Link className="linkHover" link={link}>
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default MenuList
